// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { tileSize16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-tile-size': IconTileSize;
    }
}

/**
 * The icon component for the 'tileSize' icon
 */
export class IconTileSize extends Icon {
    public constructor() {
        super(tileSize16X16);
    }
}

registerIcon('icon-tile-size', IconTileSize);
export const iconTileSizeTag = 'nimble-icon-tile-size';
